import { EquipmentType } from '@game/enums';

export const qualityColor: { [key: number]: string } = {
  0: '#b1b1b1',
  1: '#8482f3',
  2: '#43b436',
  3: '#e043ea',
  4: '#e15c4a',
};

export const qualityColorRGB: { [key: number]: string } = {
  0: '177, 177, 177',
  1: '109, 107, 241',
  2: '60, 160, 48',
  3: '224, 67, 234',
  4: '220, 64, 43',
};

export function equipmentTypeStatRequirement(equipmentType: EquipmentType): string {
  return equipmentType === EquipmentType.Unknown ? '' : 'Level';
}
